import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, unref as _unref, createSlots as _createSlots, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0be1de4b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "slide-back"
};
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fal fa-chevron-right" }, null, -1 /* HOISTED */));
import { computed, useSlots } from "vue";
import { ElDrawer } from "element-plus";
import ExtoleButton from "./Button.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ExtoleDrawer',
    props: {
        modelValue: { type: Boolean },
        showClose: { type: Boolean },
        width: { default: "33%" },
        destroyOnClose: { type: Boolean },
        lockScroll: { type: Boolean, default: false },
        hideMask: { type: Boolean, default: false },
        closeOnPressEscape: { type: Boolean, default: false }
    },
    emits: ["close", "closed", "update:modelValue"],
    setup(__props, { emit: __emit }) {
        const slots = useSlots();
        const hasHeader = computed(() => {
            return !!slots.title;
        });
        const hasFooter = computed(() => {
            return !!slots.footer;
        });
        const props = __props;
        const emit = __emit;
        const isShown = computed({
            get: () => props.modelValue,
            set: (value) => {
                emit("update:modelValue", value);
            },
        });
        const close = () => {
            isShown.value = false;
            emit("close");
        };
        const closed = () => {
            emit("closed");
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(ElDrawer), {
                onClose: close,
                onClosed: closed,
                modelValue: isShown.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((isShown).value = $event)),
                size: _ctx.width,
                "lock-scroll": _ctx.lockScroll,
                "show-close": _ctx.showClose,
                "with-header": hasHeader.value,
                "append-to-body": true,
                destroyOnClose: _ctx.destroyOnClose,
                "modal-class": _ctx.hideMask ? 'no-mask' : '',
                "close-on-press-escape": _ctx.closeOnPressEscape
            }, _createSlots({
                default: _withCtx(() => [
                    (!_ctx.showClose)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createVNode(ExtoleButton, {
                                size: "medium",
                                shape: "square",
                                level: "tertiary",
                                onClick: close
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_2
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]))
                        : _createCommentVNode("v-if", true),
                    _renderSlot(_ctx.$slots, "default")
                ]),
                _: 2 /* DYNAMIC */
            }, [
                (hasHeader.value)
                    ? {
                        name: "title",
                        fn: _withCtx(() => [
                            _renderSlot(_ctx.$slots, "title")
                        ]),
                        key: "0"
                    }
                    : undefined,
                (hasFooter.value)
                    ? {
                        name: "footer",
                        fn: _withCtx(() => [
                            _renderSlot(_ctx.$slots, "footer")
                        ]),
                        key: "1"
                    }
                    : undefined
            ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "size", "lock-scroll", "show-close", "with-header", "destroyOnClose", "modal-class", "close-on-press-escape"]));
        };
    }
});
